import { MatchmakingRound } from "model/Match/Set/Matchmaking/Track/MatchmakingRound";
import { MatchmakingRoundResult } from "model/Match/Set/Matchmaking/Track/MatchmakingRoundResult";
import {
  PointsDistribution,
  getPoints,
} from "model/Match/Set/PointsDistribution";
import { TrackRound } from "model/Match/Track/TrackRound";
import { Roster, getRosterId, getRosterDriverIds } from "model/Roster/Roster";
import { RosterScope } from "model/Roster/RosterScope";

export const mapMatchmakingRounds = (
  baseRounds: TrackRound[],
  rosters: Roster[],
  rosterScope: RosterScope,
  pointsDist: PointsDistribution
) => {
  return baseRounds.map((r) =>
    mapMatchmakingRound(r, rosters, rosterScope, pointsDist)
  );
};

const mapMatchmakingRound = (
  base: TrackRound,
  rosters: Roster[],
  rosterScope: RosterScope,
  pointsDist: PointsDistribution
): MatchmakingRound => {
  const rosterRoundScores: { [rosterId: string]: number } = {};
  for (var i = 0; i < rosters.length; i++) {
    const roster = rosters[i];
    const rosterId = getRosterId(roster);
    if (!rosterId) {
      continue;
    }

    const rosterDriverIds = getRosterDriverIds(roster, rosterScope) ?? [];
    const rosterTimes = base.times.filter((t) =>
      rosterDriverIds.includes(t.driverId)
    );
    var rosterPoints = 0;
    rosterTimes.forEach((t) => (rosterPoints += getPoints(pointsDist, t)));
    rosterRoundScores[rosterId] = rosterPoints;
  }

  return {
    ...base,
    results: getRoundResults(rosterRoundScores),
  };
};

const getRoundResults = (rosterRoundScores: {
  [rosterId: string]: number;
}): MatchmakingRoundResult[] => {
  const results: MatchmakingRoundResult[] = [];
  const roundScores = Object.values(rosterRoundScores);
  if (roundScores.length === 0) {
    return results;
  }

  const bestScore = Math.max(...roundScores);
  const bestIsPoint = roundScores.filter((s) => s === bestScore).length === 1;
  const rosterIds = Object.keys(rosterRoundScores);
  for (var i = 0; i < rosterIds.length; i++) {
    const rosterId = rosterIds[i];
    const rosterRoundPoints = rosterRoundScores[rosterId];
    const rosterTrackPoints =
      rosterRoundPoints > 0 && rosterRoundPoints === bestScore && bestIsPoint
        ? 1
        : 0;
    results.push({
      rosterId,
      points: rosterRoundPoints,
      trackPoints: rosterTrackPoints,
    });
  }

  return results;
};
